import { initialProps } from '@utils/initial'
import { Request } from '@group-devs/yfp7-global-modules'
import { useEffect, useMemo } from 'react'
import { isDomain } from '@group-devs/yfp7-global-modules/utils/general'
//import { isDomain } from '../backup/utils/general'
import Error from './404'
import Head from 'next/head'
import {WellnessLayout} from '@components/Block'
import { CarouselContent, UpcomingEvents, CarouselWrapper, CardWrapper, StripEO, HeroCenter } from '@group-devs/yfp7-global-modules/components/Block'
import styles from '@group-devs/yfp7-global-modules/components/dashboard.module.css'

const request = new Request(process.env.apiDomain)

export async function getServerSideProps({req, res, query}) {
    const props = await initialProps(req, res, query);
    
    // Mark shared links for different handling
    if (query.source === 'share') {
        props.isSharedAccess = true;
    }
    
    return {
        props: props
    }
}

function DashboardWellness(props) {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    async function handleUserBadge() {
        if(props.auth.site_user){
            const contact_id = props.auth.contactId;
            await request.tracker.setBadge(contact_id);  
        }
    }

    // UPDATED: Authentication logic with shared link support
    useEffect(() => {
        // Check if this is a shared link
        const urlParams = new URLSearchParams(window.location.search);
        const isSharedLink = urlParams.get('source') === 'share';
        
        // Only require authentication if NOT a shared link
        if (!props.auth.isAuthenticated && !isSharedLink) {
            window.location.href = '/login'
        }

        if(props.reload) {
            window.location.reload()
        }
        
        // Use a delayed approach for the badge handling
        if(props.auth.site_user){
            const timer = setTimeout(() => {
                handleUserBadge();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [])

    const userId = props.auth.site_owner ? props.auth.userId : null
    const contactId = props.auth.site_user ? props.auth.contactId : null;

    const site = props.site;

    const { data: info } = request.account.swrAccountProfileData(site.accountId, "account_user_trial_info");
    const config = info && info.data ? JSON.parse(info.data) : ''
    const tag = config ? config.company_name : 'Shaklee';

    const storyTags = ["Living Proof Stories"];
    if (storyTags) {
      //storyTags.push(tag);
    }

    const spotlightTags = ["Product Spotlight"]
    if (spotlightTags) {
      //spotlightTags.push(tag);
    }

    const { data: eo } = request.website.swrSite(site.accountId, "EO")
    const { data: categories } = request.content.swrCategories({ section: "wellness-center", tags: ["Main Category"], sort: "NAME_ASC", limit:12 })
    const { data: continueReviews } = request.content.swrArticles({ section: "wellness-center", tags: [tag], except_types: [13], sort: "DATE_DESC", limit: 12, user_id: userId, contact_id: contactId, percentage: [2,99] })
    const { data: recent } = request.content.swrArticles({ section: "wellness-center", tags: [tag], except_types: [13], sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: replays } = request.content.swrArticles({ section: "wellness-center", tags: [tag], type:11, sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: shaklee } = request.content.swrArticles({ section: "wellness-center", tags: ['Shaklee'], sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: videos } = request.content.swrArticles({ section: "wellness-center", tags: [tag], type:2, sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: recipes } = request.content.swrArticles({ section: "wellness-center", tags: [tag], type:12, sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: stories } = request.content.swrArticles({ section: "wellness-center", tags: storyTags, sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })
    const { data: products } = request.content.swrArticles({ section: "wellness-center", tags: spotlightTags, sort:"DATE_DESC", limit:12, user_id: userId, contact_id: contactId })

    const { data: accountProfileData } = request.account.swrAccountProfileData(site.accountId, 'account_profile_socialmedia');

    let discoveryGroupUrl = '';

    if (accountProfileData && accountProfileData.data) {
        try {
            const accountSocials = JSON.parse(accountProfileData.data);

            // Check if the property is explicitly undefined
            if (typeof accountSocials.facebook_group_discovery !== 'undefined' && (accountSocials.facebook_group_discovery !== '' && accountSocials.facebook_group_discovery !== null)) {
                discoveryGroupUrl = `https://www.facebook.com/groups/${accountSocials.facebook_group_discovery}`;
            }

        } catch (e) {
            console.error('Invalid JSON in accountProfileData.data:', e);
        }
    }

    // Create lightweight search index
    const searchableItems = useMemo(() => {
      // Combine all article arrays
      const allArticles = [
        ...(recent || []),
        ...(replays || []),
        ...(videos || []),
        ...(recipes || []),
        ...(stories || []),
        ...(products || []),
        ...(shaklee || []),
        ...(continueReviews || [])
      ];
      
      const uniqueArticlesMap = new Map();
      
      // Create lightweight objects with only needed properties
       allArticles.forEach(article => {
        if (!uniqueArticlesMap.has(article.id)) {
            uniqueArticlesMap.set(article.id, {
                id: article.id,
                slug: article.slug,
                title: article.title
            });
        }
    });
    
    // Convert map values to array
     return Array.from(uniqueArticlesMap.values());
    }, [recent, replays, videos, recipes, stories, products, shaklee, continueReviews]);

    const title = site.name + " - Wellness Center"
    const description = "Discover how to have long-lasting vitality and well-being with Shaklee products in my wellness center."

    //Filter video watched
    const watchedData = continueReviews ? continueReviews.filter(item => item.watched_data) : null;

    const eoUrl = eo ? (isDomain(eo.url) ? 'www.'+eo.url : eo.url) : '';

    return (
        <WellnessLayout global={props} searchItems={searchableItems}>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="keywords" content={"Your Wellness Project, Wellness Center, " + site.name} />
                <meta property="og:type" content="Website"/>
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content="/themes/014-cobalt/assets/images/img/img-share02.jpg"/>
            </Head>
            <div className="wellnessCenter">
                <HeroCenter
                    title="Let's Turn Sick Care Into Well Care!"
                    subtitle="Learn how to create health and vitality by living in harmony with nature 
                    with expert interviews, webinars, wellness articles and more."
                    shortText="Join my Wellness Community"
                    btnText="Join Group"
                    url={discoveryGroupUrl}
                    bg={styles.bgwellness}
                    target={"_blank"}
                    showBtn={!!discoveryGroupUrl}
                />

                <div className="content-container overflow-hidden position-relative">
                    {/* Hide for now since there's no backend code
                    <UpcomingEvents
                        eventLink = "/"
                        allEventsLink = {hub ? `//${hub.url}/events` : "#"}
                        eventImg="/images/test/Picture23.png"
                        eventDate="Wednesday, Sep. 9th at 9:00pm ET"
                        eventTitle="The New Athritis Relief with Dr. James Sacala"
                        bgColor="text-green border-green btng"
                        textColor="text-green"
                    />*/}

                    { watchedData && watchedData.length ?
                    <CardWrapper class="recentlyAdded" category="Continue Reviewing...">
                        <CarouselWrapper site={props.site} contents={watchedData} />
                    </CardWrapper>
                    : null }

                    { recent && recent.length ?
                    <CardWrapper class="recentlyAdded" category="Recently Added">
                        <CarouselWrapper site={props.site} contents={recent}/>
                    </CardWrapper>
                    : null }

                    { categories && categories.length ?
                    <div className="carouselContent">
                        <CardWrapper class="contentCat" category="Content Categories">
                            <CarouselContent categories={categories}/>
                        </CardWrapper>
                    </div>
                    : null }

                    { replays && replays.length ?
                    <CardWrapper class="interviews" category="Expert Interviews, Webinars & Live Streams" isExploreAll="true" url="/replays">
                        <CarouselWrapper site={props.site} contents={replays}/>
                    </CardWrapper>
                    : null }

                    { recipes && recipes.length ?
                    <CardWrapper class="healthyrecipe" category="Healthy, Tasty Recipes">
                        <CarouselWrapper site={props.site} contents={recipes}/>
                    </CardWrapper>
                    : null }
                    
                    <div className="stripeo d-lg-flex container">
                        {/* hide for now
                        <StripEO
                            title="Earn Free Products!"
                            desc="Increase your wellness IQ and earn free products by reviewing some of our best wellness content"
                            image="/images/test/Picture7.png"
                            link = "/learn-and-earn/overview"
                            imgAlt="Recommended Reading"
                            btnText="START"
                            themeColor="btn-green text-white mb-lg-0 mb-5"
                            imgsize="120"
                        />*/}
                        { eo ?
                        <StripEO
                            title="Explore the Opportunity"
                            desc={<>Learn how to create an excellent income and a lifestyle you'll love <strong>by guiding</strong> and <strong>teaching</strong> online.</>}
                            image="/images/dashboard/img-take-the-tour01.svg"
                            link = { "//" + eoUrl + "/tour"}
                            btnText="TOUR"
                            themeColor="btn-blue text-white"
                            imgsize="120"
                        />
                        : null }
                    </div>
                    
                    {/*{ stories && stories.length ?
                    <CardWrapper class="livingproof" category="Living Proof Stories">
                        <CarouselWrapper site={props.site} contents={stories}/>
                    </CardWrapper>
                    : null }

                    { products && products.length ?
                    <CardWrapper class="productspotlights" category="Product Spotlights">
                        <CarouselWrapper site={props.site} contents={products}/>
                    </CardWrapper>
                    : null }

                    { shaklee && shaklee.length && tag == "Shaklee" ?
                    <CardWrapper  class="shakleecontent" category="Shaklee Specific Content">
                        <CarouselWrapper site={props.site} contents={shaklee}/>
                    </CardWrapper>
                    : null }*/}

                    { videos && videos.length ?
                    <CardWrapper  class="vlibarary" category="Video Library" isExploreAll="true" url="/videos">
                        <CarouselWrapper site={props.site} contents={videos}/>
                    </CardWrapper>
                    : null }
                </div>

                <style jsx global>{`
                    .recentlyAdded, .livingproof{
                        margin-top:0!important;
                    }
                    .read{
                        top: -5px;
                    }
                    .stripeo{
                        margin: 10rem auto 0;
                    }
                    .catText{
                        height: 150px;
                        top: -9px; //to be deleted after Next Image Fixes
                        font-size: 1.8rem;
                    }
                    .carouselContent .slick-slide > div{
                        position:relative;
                    }
                    .cardContainer .cat-cw {
                        font-weight:600
                    }
                    .cardDetails{
                        background-color:rgb(23 23 23);
                    }
                    .content-container{
                        padding-bottom:20rem;
                    }
                    
                    @media(max-width:1440px){
                        .stripeo{
                            // margin: -10rem auto 0;
                            position: relative;
                        }
                    }
                    // @media(max-width:767px){
                    //     .stripeo{
                    //         margin-top: -11rem;
                    //         position: relative;
                    //     }
                    // }
                `}</style>
            </div>
        </WellnessLayout>
    )
}

export default DashboardWellness